const floatCta = document.getElementById("floatCta");
window.onscroll = () => {
  if (window.scrollY > 600) {
    floatCta.classList.remove("opacity-0", "invisible", "translate-y-4");
    floatCta.classList.add("opacity-100", "visible", "translate-y-0");
  } else {
    floatCta.classList.add("opacity-0", "invisible", "translate-y-4");
    floatCta.classList.remove("opacity-100", "visible", "translate-y-0");
  }
};
const notifs = document.querySelectorAll(".notif");
let ni = 0;
function showNotif() {
  if (ni >= notifs.length) ni = 0;
  notifs[ni].classList.remove("hidden");
  setTimeout(() => {
    notifs[ni].classList.add("hidden");
    ni++;
  }, 5000);
}
setTimeout(() => {
  showNotif();
  setInterval(showNotif, 35000);
}, 30000);
document
  .querySelectorAll(".notif-x")
  .forEach(
    (b) => (b.onclick = () => b.closest(".notif").classList.add("hidden")),
  );
const track = document.getElementById("sliderTrack");
const dots = document.querySelectorAll(".gallery-dot");
const prevBtn = document.getElementById("sliderPrev");
const nextBtn = document.getElementById("sliderNext");
const slides = track.querySelectorAll(".gallery-img");
let currentSlide = 0;
const totalSlides =
  typeof wp_total_images !== "undefined" && wp_total_images > 0
    ? wp_total_images
    : window.product_data?.images?.length || slides.length;
function goToSlide(index) {
  if (index < 0) index = totalSlides - 1;
  if (index >= totalSlides) index = 0;
  currentSlide = index;
  track.style.transform = `translateX(-${currentSlide * 100}%)`;
  dots.forEach((dot, i) => {
    const active = i === currentSlide;
    dot.classList.toggle("bg-ink-900", active);
    dot.classList.toggle("bg-ink-200", !active);
    dot.classList.toggle("hover:bg-ink-400", !active);
  });
}
if (prevBtn) prevBtn.addEventListener("click", () => goToSlide(currentSlide - 1));
if (nextBtn) nextBtn.addEventListener("click", () => goToSlide(currentSlide + 1));
dots.forEach((dot) => {
  dot.addEventListener("click", () => goToSlide(parseInt(dot.dataset.index)));
});
let touchStartX = 0;
track.addEventListener(
  "touchstart",
  (e) => (touchStartX = e.changedTouches[0].screenX),
  { passive: true },
);
track.addEventListener(
  "touchend",
  (e) => {
    const diff = touchStartX - e.changedTouches[0].screenX;
    if (diff > 50) goToSlide(currentSlide + 1);
    if (diff < -50) goToSlide(currentSlide - 1);
  },
  { passive: true },
);
const lightbox = document.getElementById("lightbox");
const lightboxImg = document.getElementById("lightboxImg");
const lightboxCounter = document.getElementById("lightboxCounter");
const lbDots = document.querySelectorAll(".lb-dot");
const galleryImgs = document.querySelectorAll(".gallery-img");
let lbIndex = 0;
function openLightbox(index) {
  lbIndex = index;
  updateLightbox();
  lightbox.classList.remove("hidden");
  document.body.style.overflow = "hidden";
}
function closeLightbox(e) {
  if (e && e.target !== lightbox) return;
  lightbox.classList.add("hidden");
  document.body.style.overflow = "";
}
function updateLightbox() {
  lightboxImg.src = galleryImgs[lbIndex].src;
  lightboxCounter.textContent = `${lbIndex + 1} / ${totalSlides}`;
  lbDots.forEach((dot, i) => {
    const active = i === lbIndex;
    dot.classList.toggle("bg-white", active);
    dot.classList.toggle("bg-white/30", !active);
    dot.classList.toggle("hover:bg-white/50", !active);
  });
}
function lightboxPrev() {
  lbIndex = lbIndex <= 0 ? totalSlides - 1 : lbIndex - 1;
  updateLightbox();
}
function lightboxNext() {
  lbIndex = lbIndex >= totalSlides - 1 ? 0 : lbIndex + 1;
  updateLightbox();
}
lbDots.forEach((dot) => {
  dot.addEventListener("click", () => {
    lbIndex = parseInt(dot.dataset.index);
    updateLightbox();
  });
});
document.addEventListener("keydown", (e) => {
  if (lightbox.classList.contains("hidden")) return;
  if (e.key === "Escape") closeLightbox();
  if (e.key === "ArrowLeft") lightboxPrev();
  if (e.key === "ArrowRight") lightboxNext();
});
let lbTouchStartX = 0;
lightbox.addEventListener(
  "touchstart",
  (e) => (lbTouchStartX = e.changedTouches[0].screenX),
  { passive: true },
);
lightbox.addEventListener(
  "touchend",
  (e) => {
    const diff = lbTouchStartX - e.changedTouches[0].screenX;
    if (diff > 50) lightboxNext();
    if (diff < -50) lightboxPrev();
  },
  { passive: true },
);
const reviewImgs = document.querySelectorAll(".review-img");
const reviewLb = document.getElementById("reviewLightbox");
const reviewLbImg = document.getElementById("reviewLbImg");
const reviewLbUser = document.getElementById("reviewLbUser");
const reviewLbStars = document.getElementById("reviewLbStars");
const reviewLbCounter = document.getElementById("reviewLbCounter");
const rlbDots = document.querySelectorAll(".rlb-dot");
let rlbIndex = 0;
const rlbTotal = 6;
function openReviewLightbox(index) {
  rlbIndex = index;
  updateReviewLb();
  reviewLb.classList.remove("hidden");
  document.body.style.overflow = "hidden";
}
function closeReviewLightbox() {
  reviewLb.classList.add("hidden");
  document.body.style.overflow = "";
}
function updateReviewLb() {
  const img = reviewImgs[rlbIndex];
  reviewLbImg.src = img.src;
  reviewLbUser.textContent = img.dataset.user;
  const rating = parseInt(img.dataset.rating);
  reviewLbStars.innerHTML = Array(5)
    .fill()
    .map(
      (_, i) => `<i class="fas fa-star ${i < rating ? "" : "opacity-30"}"></i>`,
    )
    .join("");
  reviewLbCounter.textContent = `${rlbIndex + 1} / ${rlbTotal}`;
  rlbDots.forEach((dot, i) => {
    dot.classList.toggle("bg-white", i === rlbIndex);
    dot.classList.toggle("bg-white/30", i !== rlbIndex);
  });
}
function reviewLbPrev() {
  rlbIndex = rlbIndex <= 0 ? rlbTotal - 1 : rlbIndex - 1;
  updateReviewLb();
}
function reviewLbNext() {
  rlbIndex = rlbIndex >= rlbTotal - 1 ? 0 : rlbIndex + 1;
  updateReviewLb();
}
rlbDots.forEach((dot) => {
  dot.addEventListener("click", () => {
    rlbIndex = parseInt(dot.dataset.index);
    updateReviewLb();
  });
});
reviewLb.addEventListener("click", (e) => {
  if (e.target === reviewLb) closeReviewLightbox();
});
document.addEventListener("keydown", (e) => {
  if (reviewLb.classList.contains("hidden")) return;
  if (e.key === "Escape") closeReviewLightbox();
  if (e.key === "ArrowLeft") reviewLbPrev();
  if (e.key === "ArrowRight") reviewLbNext();
});
let rlbTouchX = 0;
reviewLb.addEventListener(
  "touchstart",
  (e) => (rlbTouchX = e.changedTouches[0].screenX),
  { passive: true },
);
reviewLb.addEventListener(
  "touchend",
  (e) => {
    const diff = rlbTouchX - e.changedTouches[0].screenX;
    if (diff > 50) reviewLbNext();
    if (diff < -50) reviewLbPrev();
  },
  { passive: true },
);
function toggleFaq(btn) {
  const item = btn.closest(".faq-item");
  const content = item.querySelector(".faq-content");
  const allItems = document.querySelectorAll(".faq-item");
  allItems.forEach((i) => {
    if (i !== item) {
      i.classList.remove("active");
      i.querySelector(".faq-content").classList.add("hidden");
    }
  });
  item.classList.toggle("active");
  content.classList.toggle("hidden");
}
